import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-900">热门话题</h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col gap-2 p-4 md:p-5 rounded-xl bg-background-50 hover:bg-accent-50/50 transition-colors border border-background-200/70 cursor-pointer"
            >
              <div className="flex items-start justify-between gap-2">
                <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-secondary-100 text-secondary-600 whitespace-nowrap">
                  {topic.category}
                </span>
                <div className="flex items-center gap-1 flex-shrink-0">
                  {topic.trend === 'hot' ? (
                    <i className="ri-fire-line text-accent-500 text-sm"></i>
                  ) : topic.trend === 'up' ? (
                    <i className="ri-arrow-up-line text-primary-500 text-sm"></i>
                  ) : (
                    <i className="ri-arrow-down-line text-secondary-400 text-sm"></i>
                  )}
                  <span className="text-xs font-bold text-foreground-500 whitespace-nowrap">{topic.heat}</span>
                </div>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-800 group-hover:text-accent-600 transition-colors line-clamp-2 leading-snug">
                # {topic.name}
              </h3>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}